import React, { useEffect, useState } from "react";
import Logo from "../../images/logo.svg";
import { Link, useNavigate } from "react-router-dom";
import InputGroup from "../../components/InputGroup";
import Toggle from "../../components/Toggle";
import axios from "../../helpers/axios";
import { useDispatch, useSelector } from "react-redux";
import { login, setAdminData } from "../../redux/slice/authSlice";
import { toast } from "react-toastify";

export default function Login() {
  const AdminLoggedData = JSON.parse(localStorage.getItem("AdminLoggedData"));
  const [data, setData] = useState({
    email: "",
    password: "",
    rememberMe: false,
  });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [resetPwd, setresetPwd] = useState(false);
  const [resetLinkMsg, setresetLinkMsg] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const authInfo = useSelector((state) => state.auth);

  const handlePwdLink = async () => {
    let emailRegx = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    if (!emailRegx.test(data.email)) {
      setError("Invalid Email");
    } else {
      const resp = await axios
        .post("admin/forgot/password", { email: data.email })
        .then((resp) => {
          if (resp.status < 400) {
            toast.success(resp.data?.message);
            setresetLinkMsg(true);
          }
        })
        .catch((err) => {
          const respCode = err?.response?.status;
          if (respCode === 401) {
            toast.error("Entered email is Not Registered");
          } else {
            toast.error(err?.message);
          }
        });
    }
  };

  const onSubmit = async (e) => {
    if (resetPwd) {
      handlePwdLink();
    } else {
      try {
        setError(false);
        e.preventDefault();
        setLoading(true);
        let res = await axios.post("admin/login", data);
        //console.log("res==", res)
        if (res.data.resp_code === 200) {
          //console.log("200", (res.data.resp_code));
          dispatch(login(res.data.data));
          dispatch(setAdminData(res.data?.data));
          if (data?.rememberMe) {
            localStorage.setItem("AdminLoggedData", JSON.stringify(data));
          } else {
            localStorage.removeItem("AdminLoggedData");
          }
          if (authInfo.authToken && authInfo.isLoggedIn) {
            await axios.interceptors.request.use(
              async (config) => {
                config.headers.Authorization = authInfo.authToken;
                return config;
              },
              (error) => {
                //console.log("Token error", error.message);
                return Promise.reject(error);
              }
            );
          }
          setLoading(false);
          return navigate("/");
        }
      } catch (error) {
        setLoading(false);
        //console.log(error);
        setError(error.response.data.errors.invalid_credentials);
      }
    }
  };

  useEffect(() => {
    if (
      AdminLoggedData !== null &&
      AdminLoggedData !== undefined &&
      Object.keys(AdminLoggedData)?.length > 0
    ) {
      setData(AdminLoggedData);
    } else {
      setData({
        email: "",
        password: "",
        rememberMe: false,
      });
    }
  }, []);

  useEffect(() => {
    async function setAxios() {
      if (authInfo.token && authInfo.isLoggedIn) {
        await axios.interceptors.request.use(
          async (config) => {
            config.headers.Authorization = `Bearer ${authInfo.token}`;
            return config;
          },
          (error) => {
            //console.log("Token error", error.message);
            return Promise.reject(error);
          }
        );
        return navigate("/dashboard");
      }
    }
    setAxios();
  }, []);

  //console.log("resetPwd", resetPwd);
  return (
    <div className="md:grid md:grid-cols-5 md:h-screen">
      <div className="md:col-span-2 md:p-2 md:h-full">
        <div className="bg-loginBg h-full md:rounded-md content-end flex-col justify-end p-12 py-8 flex pt-40 relative overflow-hidden bg-center md:py-16">
          <div className="container justify-end z-20">
            <h1 className="text-2xl text-white font-bold mb-1">
              Discover, Collaborate, Win
            </h1>
            <p className="text-sm text-white mb-4">
              Discover customer pain points, Collaborate to achieve those using
              OhhTo and get more bonus and get customers.
            </p>
            <button type="button" to={"/"} className="btn-xl">
              View more
            </button>
          </div>
          <div className="absolute w-full h-full z-10 bg-black opacity-70 left-0 top-0"></div>
        </div>
      </div>
      <div className="md:col-span-3 md:h-screen">
        <div className="h-auto md:h-full flex py-8">
          <div className="my-auto  mx-auto w-full max-w-sm px-4 md:px-2">
            <img src={Logo} className="mx-auto mb-8" />
            <h1 className="text-xl font-bold text-center">Hi, Welcome Back</h1>
            <p className="text-sm text-gray-500 text-center">
              to the new auto portal
            </p>
            {resetLinkMsg ? (
              <div className="py-[30px] text-center">
                <p className="font-[500] mb-[8px]">
                  Reset password link sent successfully!!
                </p>
                <p className="font-[500] mb-[8px]">
                  Please Check Your Email{" "}
                  <span className="border-b border-slate-600">
                    {data.email}
                  </span>
                </p>
              </div>
            ) : (
              <form className="mt-12" onSubmit={onSubmit} autoComplete={"off"}>
                <InputGroup
                  type="email"
                  label="Email Address"
                  placeholder="johndoe@workemail.com"
                  value={data.email}
                  setValue={(value) =>
                    setData((data) => ({ ...data, email: value }))
                  }
                  required={true}
                />
                {!resetPwd && (
                  <>
                    <InputGroup
                      type="password"
                      label="Password"
                      placeholder="8+ Characters required"
                      value={data.password}
                      setValue={(value) =>
                        setData((data) => ({ ...data, password: value }))
                      }
                      required={true}
                    />

                    <div className="flex justify-between">
                      <Toggle rememberMe={data?.rememberMe} setData={setData} />
                      <Link
                        className="text-sm text-blue-700 font-medium"
                        onClick={() => setresetPwd(true)}
                      >
                        Forgot Password
                      </Link>
                      {/* <Link
                        className="text-sm text-blue-700 font-medium"
                        to={"/resetpassworrd/5847987F6476"}
                      >
                        Reset Password
                      </Link> */}
                    </div>
                  </>
                )}
                <div className="relative mt-4">
                  {resetPwd ? (
                    <button
                      type="button"
                      className="btn-xl w-full mt-4 mb-6"
                      disabled={loading}
                      onClick={handlePwdLink}
                    >
                      Get Password Link
                    </button>
                  ) : (
                    <button
                      type="submit"
                      className="btn-xl w-full mt-4 mb-6"
                      disabled={loading}
                    >
                      {loading ? "Logging In " : "Login"}
                    </button>
                  )}
                  {error ? (
                    <div className="w-full absolute left-0 bottom-0 flex items-center pointer-events-none overflow-hidden h-4">
                      <div className="text-center w-full">
                        <p className="text-red-600 h-[20px] text-[14px] tracking-tight font-medium">
                          {error}
                        </p>
                      </div>
                    </div>
                  ) : null}
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
